
<template>
    {{message}}
</template>


<script>
import { Head } from '@inertiajs/inertia-vue3'

export default {
    components: {
        Head
    },
    props: {
        message: String
    }
}
</script>
